module.exports = __webpack_public_path__ + "static/pulsio_6_boxes-a46bc713ba1664f07c6b4f25abcaf8ad.png";